<script setup lang="ts">
import { UiText, UiIcon, UiAvatar } from "@shopexperts/shared";
import { partyName, type TransactionParty } from "./transactionParty";

defineProps<{
  parties: TransactionParty[];
}>();
</script>

<template>
  <div
    v-if="parties.length"
    class="flex flex-wrap items-center gap-x-6 gap-y-2.5 rounded-lg border border-se-gray-200 bg-se-gray-50/70 px-3 py-2.5"
  >
    <component
      :is="party.to ? 'RouterLink' : 'div'"
      v-for="party in parties"
      :key="party.key"
      :to="party.to"
      class="group/party flex min-w-0 items-center gap-2.5 rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-se-dark"
      :class="party.to ? 'cursor-pointer' : ''"
      :aria-label="party.to ? `Open ${partyName(party.user)}'s expert profile` : undefined"
    >
      <UiAvatar
        :name="party.user.name ?? undefined"
        :url="party.user.avatar ?? undefined"
        size="xs"
        :responsive="false"
        color-coded
      />
      <div class="flex min-w-0 flex-col leading-tight">
        <UiText as="span" variant="caption" class="text-se-gray-500" :text="party.role" />
        <span class="flex min-w-0 items-center gap-1">
          <UiText
            as="span"
            variant="p-small"
            :text="partyName(party.user)"
            class="min-w-0 truncate font-semibold text-se-dark"
            :class="party.to ? 'group-hover/party:underline' : ''"
          />
          <UiIcon
            v-if="party.to"
            name="link-external"
            class="h-3 w-3 shrink-0 text-se-gray-400 transition-colors group-hover/party:text-se-dark"
          />
        </span>
      </div>
    </component>
  </div>
</template>
